// Mock data for Toronto Royale Chauffeur Service

export const heroImages = {
  home: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/2b727e7f8fb6acadc36de08abcc780a863eec53af3ebd5e6c6cfd9f92f96a0d7.png",
  services: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/94d79e4d61a67ee4ae6ae48fa6bc49a1f6ee94522efc8ba46c363bc2eb0a8d03.png",
  about: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/53cef90fe242f689f80a348434e0e294d47d83993beba3ff8af64c3c8afc237a.png",
  contact: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/f20a68b23b52d0c0868da1274595c79cf3230a6ac185e40ef20d727770bb5c03.png",
  founder: "https://images.unsplash.com/photo-1701463387028-3947648f1337?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxleGVjdXRpdmUlMjBidXNpbmVzc21hbiUyMHByb2Zlc3Npb25hbCUyMGRhcmslMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzEzNTg0NzN8MA&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: 1,
    title: "Executive Travel",
    description: "Discreet, dependable transportation for business leaders who value consistency and professionalism.",
    image: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/6c33f512a3133fbecfe46b642c01005369b6c5b08145d4b65f5956034667f3e0.png",
    features: ["Consistent chauffeur", "Priority scheduling", "Discretion guaranteed", "Flexible routes"]
  },
  {
    id: 2,
    title: "Airport Transfers",
    description: "Stress-free arrivals and departures with flight tracking, warm greetings, and timely service.",
    image: "https://static.prod-images.emergentagent.com/jobs/f497abda-7ba8-4fbb-8b5f-c19f77198a94/images/7f73e4714df38a957397571978e2496aa2249d29fae3675776dce581e9d0b26f.png",
    features: ["Flight tracking", "Meet & greet", "Luggage assistance", "On-time guarantee"]
  },
  {
    id: 3,
    title: "Family Chauffeur",
    description: "Safe, reliable transportation for your loved ones, trusted by families who value care and consistency.",
    image: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/ace90da205097a2f164d663fdc781c25ccd1e1ca229cee4d4db88f587d075d5e.png",
    features: ["Trusted driver", "Safety first", "Flexible scheduling", "Peace of mind"]
  },
  {
    id: 4,
    title: "Special Occasions",
    description: "Weddings, celebrations, and milestones \u2014 we're honored to be part of your most memorable moments.",
    image: "https://static.prod-images.emergentagent.com/jobs/9cbc49fb-8ba6-4770-b86f-5985bca0990c/images/5d8fda304bc747f5fee0fa692d99c7ed189ed89c63ea0b4dead8989a8b34a7d5.png",
    features: ["White-glove service", "Personal attention", "Timely arrival", "Memorable experience"]
  }
];

export const experiencePillars = [
  {
    title: "A Familiar Face",
    description: "The same vetted chauffeur for your family — recognized by your children, trusted by you."
  },
  {
    title: "Unhurried",
    description: "We move at your pace. No rush, no surge pricing, no stress — only calm, attentive service."
  },
  {
    title: "Quietly Personal",
    description: "We remember your preferences — car seats, temperature, the route your son prefers home from school."
  },
  {
    title: "Safety First",
    description: "Defensive driving, vetted chauffeurs, real-time arrival tracking, and child-seat options on request."
  },
  {
    title: "Discreet",
    description: "Confidential by default. Your schedule, conversations, and home address stay private."
  },
  {
    title: "Always Reachable",
    description: "A direct line to the founder — not a call centre. Real people, every time you reach out."
  }
];

export const whyChooseUs = [
  {
    title: "Founder-Led",
    description: "Built by one person who believes a family chauffeur should be rooted in trust, not transactions.",
    icon: "Heart"
  },
  {
    title: "The Same Chauffeur",
    description: "Recurring families ride with the same trusted driver every time. Consistency you can plan around.",
    icon: "Users"
  },
  {
    title: "Human, Not a Hotline",
    description: "We listen, we remember, we adapt. This is private hospitality — not an app, not a fleet.",
    icon: "MessageCircle"
  }
];

export const values = [
  {
    title: "Respect",
    description: "We honor your time, your privacy, and your trust."
  },
  {
    title: "Reliability",
    description: "When we say we'll be there, we're there. Every time."
  },
  {
    title: "Care",
    description: "Your comfort and safety are our highest priorities."
  },
  {
    title: "Discretion",
    description: "Your conversations and schedule are always confidential."
  },
  {
    title: "Consistency",
    description: "The same exceptional service, every journey."
  },
  {
    title: "Human Connection",
    description: "We build relationships, not just complete rides."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "M.H.",
    role: "Executive",
    content: "Toronto Royale isn't just a car service. It's peace of mind. I know exactly who's picking me up, and I trust them completely.",
    rating: 5
  },
  {
    id: 2,
    name: "S.C.",
    role: "Private Client",
    content: "The consistency is remarkable. Same driver, same warmth, same care. It feels like having a trusted colleague.",
    rating: 5
  },
  {
    id: 3,
    name: "D.T.",
    role: "Family Client",
    content: "This is different. They actually care, and it shows in every detail.",
    rating: 5
  }
];

export const founderInfo = {
  name: "Toronto Royale",
  title: "Founder",
  story: "I started Toronto Royale because I saw something missing in transportation\u2014respect, consistency, and genuine human connection. This isn't about building the biggest service. It's about building the right one. Where clients are treated with care. Where relationships matter more than transactions. Where every journey reflects a commitment to integrity.",
  mission: "Every journey is an opportunity to serve with warmth and reliability. That's my promise to you.",
  image: "https://images.unsplash.com/photo-1701463387028-3947648f1337?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxleGVjdXRpdmUlMjBidXNpbmVzc21hbiUyMHByb2Zlc3Npb25hbCUyMGRhcmslMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzEzNTg0NzN8MA&ixlib=rb-4.1.0&q=85"
};

export const contactInfo = {
  phone: "+1 (437) 996-3801",
  email: "bookings@torontoroyale.com",
  serviceArea: "Greater Toronto Area",
  hours: "Available 24/7 for your convenience",
  googleReviewUrl: "https://g.page/r/CQI5hmWDs6jVEAE/review"
};
